import { AdditionalData } from "views/applications-id-report/slices/CombinedIncomeReportSlice/types/verified/bank-statment";
import { getGenericReasonCodes } from "../../utils";
import { DocumentCard } from "views/applications-id-report/slices/IncomeReportSlice/components/DocumentCard";
import { documentWithoutDatesTableColumns } from "views/applications-id-report/slices/CombinedIncomeReportSlice/helpers";
import { ExpandableTable } from "views/applications-id-report/slices/CombinedIncomeReportSlice/components/UniversalTable";
import { UploadedIncomeSource } from "views/applications-id-report/slices/CombinedIncomeReportSlice/types/income";

export const UnverifiedIncomeSourceTable = ({
  incomeSources
}: {
  incomeSources: UploadedIncomeSource[];
}) => {
  return (
    <ExpandableTable
      cellClassName="p-4 pl-0 text-sm self-center"
      headerRowClassName="text-content-300"
      renderExpanded={(row) => {
        const additionalData = (row.rejection_reason ?? []).reduce(
          (additionalData, reason) => {
            additionalData[reason] = true;
            return additionalData;
          },
          {} as AdditionalData
        );

        const reasonCodes = getGenericReasonCodes(
          additionalData,
          row.verifyType
        );

        return (
          <div className="px-6 py-8 bg-background-900">
            <DocumentCard
              score={row.trust_score ?? 0}
              asset={row.asset?.asset}
              reasonCodes={reasonCodes}
              ignorePrint
            />
          </div>
        );
      }}
      columns={documentWithoutDatesTableColumns}
      rows={(incomeSources ?? []).map((item) => ({
        ...item,
        verifyType: item.type,
        asset: item.asset
      }))}
    />
  );
};
